export default __webpack_public_path__ + "static/media/Note_Taker.a8eadfe1.png";